import SodAccountChip from './SodAccountChip';
export default SodAccountChip;
